import axios from "@/lib/axios";

export type NewUserRequestParams = {
  companyId: string;
  name: string;
  email: string;
};

export type NewUserResponse = {
  id: string;
};

export const newUser = (params: NewUserRequestParams) =>
  axios
    .post<NewUserResponse>(`/v1/companies/${params.companyId}/users`, {
      name: params.name,
      email: params.email,
    })
    .then((res) => res.data);
